module.exports = __webpack_public_path__ + "fonts/THICCCBOI-Black.65d66469.woff";